import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CampaignBuilder } from '../sections/CampaignBuilder';
import { getPartnerId, isPartnerAuthed } from '../lib/partnerAuth';

/**
 * Self-serve campaign builder page (epic-10, v1-10-2; partner-wired v3-17).
 *
 * Partner-facing: a logged-in partner builds a new campaign DRAFT and submits it
 * into the operator review queue. Gated on the partner session — the builder's
 * API calls carry the partner JWT (see jsonFetch).
 */
export function CampaignBuilderPage() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!isPartnerAuthed()) navigate('/partner/login', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-primary px-4 py-2 focus:text-white"
      >
        Skip to content
      </a>
      <Navbar />
      <main id="main">
        <CampaignBuilder partnerId={getPartnerId() ?? ''} />
      </main>
      <Footer />
    </div>
  );
}

export default CampaignBuilderPage;
